import { MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { AllSection } from "../models/AllSection";

export const getAllSections = async (
	signal?: AbortSignal,
): Promise<AllSection[]> => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[MT].[GetAllSections]", [], signal);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as AllSection[];
	} else throw new Error(resp.message || "Error fetching sections");
};
